<div class="notifications">
  <div
    ngbDropdown
    #notificationDropdown="ngbDropdown"
    class="d-inline-block"
    [placement]="railMode() ? 'left-top' : 'bottom'"
    (openChange)="onDropdownOpen($event)">
    <!-- Rail placement: the bell is a right-rail button (see `railMode`); the menu opens
         to the left of the rail from this anchor. -->
    @if (railMode()) {
      <span ngbDropdownAnchor class="notification-rail-anchor" id="notifications"></span>
    } @else {
      <button
        class="btn notification-dropdown-btn text-black"
        id="notifications"
        (click)="buzzerOff()"
        ngbDropdownToggle
        [ngClass]="isVisited()">
        <i class="fa fa-bell-o fa-fw" [ngClass]="{ 'bell-buzzer': newmessage }" aria-hidden="true"></i>
        <span [ngSwitch]="status" class="me-1">
          <span *ngSwitchCase="'LOADED'">{{ unseenTotal }}</span>
          <mtm-loading-spinner *ngSwitchCase="'LOADING'" [size]="14" [color]="'#ffffff'"></mtm-loading-spinner>
          <i *ngSwitchCase="'ERROR'" class="fa fa-exclamation-triangle fa-fw"></i>
        </span>
      </button>
    }
    <div
      ngbDropdownMenu
      aria-labelledby="notifications"
      class="pb-0 combobox-notifications exclude-backdrop new-notif-popover"
      [class.notification-rail-menu]="railMode()"
      [style.--rail-menu-top.px]="railMenuAt().top"
      [style.--rail-menu-right.px]="railMenuAt().right"
      [ngClass]="{ 'loareal-notification': isHrUser || isYslUser }">

      <!-- Header Section -->
      <div class="popover-header d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
        <div class="d-flex align-items-center gap-2">
          <span class="header-title">Notifications</span>
          <span class="unread-badge" *ngIf="unseenTotal > 0">{{ unseenTotal }}</span>
        </div>
        <div class="d-flex align-items-center gap-3 header-actions">
          <button class="btn btn-link p-0 read-all-btn text-decoration-none d-flex align-items-center" (click)="markNotificationsAsRead()">
            <mtm-read-all-icon class="me-1 d-flex align-items-center"></mtm-read-all-icon>Read all
          </button>
          <button class="btn btn-link p-0 settings-btn d-flex align-items-center" (click)="goToSettings()" title="Notification Settings">
            <mtm-notification-settings-icon class="d-flex align-items-center"></mtm-notification-settings-icon>
          </button>
          <button
            type="button"
            class="btn btn-link p-0 close-btn text-decoration-none d-flex align-items-center"
            (click)="notificationDropdown.close()"
            [title]="'close' | translate"
            [attr.aria-label]="'close' | translate">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <!-- Filter Tabs Section -->
      <div class="popover-tabs d-flex px-3 border-bottom">
        <button
          class="tab-btn me-3 pb-2"
          [class.active]="activeTab === 'all'"
          (click)="setActiveTab('all')">
          All <span class="tab-badge ms-1" [class.active-badge]="activeTab === 'all'">{{ allCount }}</span>
        </button>
        <button
          class="tab-btn me-3 pb-2"
          [class.active]="activeTab === 'unread'"
          (click)="setActiveTab('unread')">
          Unread <span class="tab-badge ms-1" [class.active-badge]="activeTab === 'unread'">{{ unreadCount }}</span>
        </button>
        <button
          class="tab-btn pb-2"
          [class.active]="activeTab === 'mentions'"
          (click)="setActiveTab('mentions')">
          Mentions <span class="tab-badge ms-1" [class.active-badge]="activeTab === 'mentions'">{{ mentionsCount }}</span>
        </button>
      </div>

      <!-- Loader -->
      <div *ngIf="status === 'LOADING'" class="w-100 spinner h-100 text-center backdrop-overlay align-content-center">
        <mtm-loading-spinner [size]="32" [color]="'#ffffff'"></mtm-loading-spinner>
      </div>

      <!-- Notification List -->
      <div *ngIf="status === 'LOADED'" class="w-100 list-container p-3" [attr.aria-busy]="listLoading">
        <!-- Tab switch loader: scoped to the list so the bell and page stay untouched -->
        @if (listLoading) {
          <div class="list-loader d-flex align-items-center justify-content-center">
            <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
          </div>
        }

        <!-- Today / Earlier Section -->
        <div class="mb-3" *ngIf="!listLoading && todays.length > 0">
          <div class="section-label mb-2">{{ 'today' | translate | uppercase }}</div>
          <div class="d-flex flex-column gap-2">
            @for (notification of todays; track $index) {
              <div
                class="notification-card p-2 rounded"
                [class.unread-card]="!notification.seen"
                (click)="onNotificationItemClick($event, notification)">
                <!-- Sub-header context & Hover Actions -->
                <div class="card-sub-header d-flex justify-content-between align-items-center mb-1">
                  <span class="context-title">{{ getItemContextTitle(notification) }}</span>
                  <!-- <div class="card-actions d-flex gap-2">
                    <button class="action-btn d-flex align-items-center" (click)="replyNotification($event, notification)" title="Reply">
                      <mtm-reply-icon class="d-flex align-items-center"></mtm-reply-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="muteNotification($event, notification)" title="Mute">
                      <mtm-unmute-icon class="d-flex align-items-center"></mtm-unmute-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="deleteNotificationItem($event, notification)" title="Delete">
                      <mtm-archive-icon class="d-flex align-items-center"></mtm-archive-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="markSingleAsRead($event, notification)" title="Mark as read">
                      <mtm-checked-icon class="d-flex align-items-center"></mtm-checked-icon>
                    </button>
                  </div> -->
                </div>

                <!-- Card Body -->
                <div class="card-body-row d-flex align-items-start gap-2">
                  <span class="unread-dot" *ngIf="!notification.seen"></span>
                  <mtm-user-profile-picture
                    [forceLoadProfile]="true"
                    [username]="notification.object?.notifiedByUsername"
                    [avatarUrl]="notification.object?.notifiedByAvatarUrl"
                    [height]="28"
                    [width]="28">
                  </mtm-user-profile-picture>
                  <div class="card-content flex-grow-1 overflow-hidden">
                    <div class="author-line d-flex align-items-center flex-nowrap gap-1">
                      <span class="author-name text-truncate">{{ notification.object?.notifiedBy || 'User' }}</span>
                      <span class="to-label text-muted flex-shrink-0">to</span>
                      <span class="channel-badge d-inline-flex align-items-center flex-shrink-0">
                        <mtm-globe-icon class="me-1 d-flex align-items-center"></mtm-globe-icon><span class="hash-symbol">#</span>&nbsp;{{ getChannelName(notification) }}
                      </span>
                    </div>
                    <div class="message-row d-flex align-items-center justify-content-between gap-2">
                      <div class="message-text text-truncate flex-grow-1">
                        {{ notification.notificationDisplay?.label }}
                      </div>
                      <span class="timestamp-label flex-shrink-0 text-nowrap ms-auto">
                        {{ getRelativeTime(notification.date) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Past Section -->
        <div class="mb-3" *ngIf="!listLoading && past.length > 0">
          <div class="section-label mb-2">EARLIER</div>
          <div class="d-flex flex-column gap-2">
            @for (notification of past; track $index) {
              <div
                class="notification-card p-2 rounded"
                [class.unread-card]="!notification.seen"
                (click)="onNotificationItemClick($event, notification)">
                <!-- Sub-header context & Hover Actions -->
                <div class="card-sub-header d-flex justify-content-between align-items-center mb-1">
                  <span class="context-title">{{ getItemContextTitle(notification) }}</span>
                  <!-- <div class="card-actions d-flex gap-2">
                    <button class="action-btn d-flex align-items-center" (click)="replyNotification($event, notification)" title="Reply">
                      <mtm-reply-icon class="d-flex align-items-center"></mtm-reply-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="muteNotification($event, notification)" title="Mute">
                      <mtm-unmute-icon class="d-flex align-items-center"></mtm-unmute-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="deleteNotificationItem($event, notification)" title="Delete">
                      <mtm-archive-icon class="d-flex align-items-center"></mtm-archive-icon>
                    </button>
                    <button class="action-btn d-flex align-items-center" (click)="markSingleAsRead($event, notification)" title="Mark as read">
                      <mtm-checked-icon class="d-flex align-items-center"></mtm-checked-icon>
                    </button>
                  </div> -->
                </div>

                <!-- Card Body -->
                <div class="card-body-row d-flex align-items-start gap-2">
                  <span class="unread-dot" *ngIf="!notification.seen"></span>
                  <mtm-user-profile-picture
                    [forceLoadProfile]="true"
                    [username]="notification.object?.notifiedByUsername"
                    [avatarUrl]="notification.object?.notifiedByAvatarUrl"
                    [height]="28"
                    [width]="28">
                  </mtm-user-profile-picture>
                  <div class="card-content flex-grow-1 overflow-hidden">
                    <div class="author-line d-flex align-items-center flex-nowrap gap-1">
                      <span class="author-name text-truncate">{{ notification.object?.notifiedBy || 'User' }}</span>
                      <span class="to-label text-muted flex-shrink-0">to</span>
                      <span class="channel-badge d-inline-flex align-items-center flex-shrink-0">
                        <mtm-globe-icon class="me-1 d-flex align-items-center"></mtm-globe-icon><span class="hash-symbol">#</span>&nbsp;{{ getChannelName(notification) }}
                      </span>
                    </div>
                    <div class="message-row d-flex align-items-center justify-content-between gap-2">
                      <div class="message-text text-truncate flex-grow-1">
                        {{ notification.notificationDisplay?.label }}
                      </div>
                      <span class="timestamp-label flex-shrink-0 text-nowrap ms-auto">
                        {{ getRelativeTime(notification.date) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="text-center py-4" *ngIf="!listLoading && !todays?.length && !past?.length">
          <h6 class="text-muted">{{ 'NoRecentNotification' | translate }}</h6>
        </div>
      </div>

      <!-- Footer Bar -->
      <div class="popover-footer d-flex align-items-center justify-content-between px-3 py-2 border-top">
        <button class="btn btn-link p-0 view-all-link text-decoration-none" (click)="goToNotification()">
          View all &rarr;
        </button>
        <span class="updated-time text-muted">Updated just now</span>
      </div>
    </div>

    <div class="backdrop-overlay" *ngIf="isDropdownOpen"></div>
  </div>
</div>
